import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
// reactstrap components
import { Row } from 'reactstrap';

import { Desktop } from '../../Common/const.jsx';
// import SwitchBtn from '../../Common/SwitchBtn/switchBtn';
import flashcard from '../../Study/FlashcardComplete/flashcard.json';

class FlashcardCompleteHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = { alert: false };
  }

  handleOnAlert = (active) => {
    this.setState({
      alert: active,
    });
    this.props.receiveQuestionsNotification(
      active,
      this.props.questionNotificationState,
    );
  };

  render() {
    return (
      <div>
        <Row className="d-flex align-items-center justify-content-center flex-column mr-0 ml-0 first-row-flashcard-complete">
          <div className="good-job-title mb-2 mt-2 mb-md-0 mt-md-0">
            Good job!
          </div>
          <div className="all-questions-title mr-4 ml-4">
            You've completed all questions currently avaiable for this topic.
          </div>

          <div className="next-questions-title mt-2">
            Next questions due in {flashcard.avaiableQuestionTime} hours
          </div>
        </Row>

        <Desktop>
          <div className="gradient-divider-flashcard-finished" />
        </Desktop>

        <Row className="d-flex align-items-center justify-content-center mr-0 ml-0 pt-4 pb-4 bottom-row-flashcard-complete">
          {/* <SwitchBtn
            checked={this.state.alert}
            onChange={() => this.handleOnAlert(!this.state.alert)}
          />
          <div className="alert-text ml-0 ml-md-3">
            Alert me when more questions are avaiable for this topic
          </div> */}
          <Link
            to="/app/study"
            className="btn btn-call-to-action text-center m-auto"
            data-test="completed-questions-button"
          >
            CONTINUE STUDYING
          </Link>
        </Row>
      </div>
    );
  }
}

FlashcardCompleteHeader.propTypes = {
  // objects given by the container
  avaiableQuestionTime: PropTypes.number,
};

export default FlashcardCompleteHeader;
